import cn from 'classnames';
import React, { FC } from 'react';

import styles from './MobileBasicLayout.module.scss';

export type MobileBasicLayoutProps = {
  fullWidth?: boolean;
  footerWithSettings?: boolean;
  className?: string;
  testID?: string;
  children?: React.ReactNode;
};

export const MobileBasicLayout: FC<MobileBasicLayoutProps> = (props) => {
  const {
    fullWidth = false,
    footerWithSettings = false,
    className,
    testID,
    children,
  } = props;

  return (
    <div
      className={cn(
        styles.container,
        fullWidth && styles.fullWidth,
        footerWithSettings && styles.footerWithSettings,
        className,
      )}
      data-testid={testID}
    >
      {children}
    </div>
  );
};
